import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import app from './modules/app';
import session from './modules/session';
import account from './modules/account';
import member from './modules/member';
import saveOrder from './modules/saveOrder';
import project from './modules/project';
import city from './modules/city';
import workOrder from './modules/workOrder';
import activity from './modules/activity';
import newOwner from './modules/newOwner';
var store = new Vuex.Store({
    state: {
    //
    },
    mutations: {
    //
    },
    actions: {},
    modules: {
        app: app,
        session: session,
        account: account,
        member: member,
        saveOrder: saveOrder,
        project: project,
        city: city,
        workOrder: workOrder,
        activity: activity,
        newOwner: newOwner,
    }
});
export default store;
